var App = App || {};

App.SharedForm = (function ($) {
    'use strict';

    function init() {
        $("form.kentico-form").each(function (e) {
            FormLoad($(this));
            FormSubmit($(this));
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // FORM LOAD
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function FormLoad(Form) {
        Form.find(".ktc-radio-list > span.ktc-radio, span.ktc-checkbox").each(function () {
            var input = $(this).find("input.form-control");
            var label = $(this).find("label");
            var id = input.attr("id").replace(" ", "_");

            input.removeClass("form-control").addClass("form-check-input").attr("id", id);
            label.addClass("form-check-label").attr("for", id);

            var markup = $(this).html();
            $(this).replaceWith("<div class=\"form-check\">" + markup + "</div>");
        });

        // different validation tactics
        Form.find(".zag-validation-input-text").on("input", function () { ValidateText($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-radio").on("input", function () { ValidateRadio($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-checkboxes").on("input", function () { ValidateCheckboxes($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-checkbox").on("input", function () { ValidateCheckbox($(this)); CountErrors($(this)); });
        Form.find(".zag-validation-input-file").on("input", function () { ValidateFile($(this)); CountErrors($(this)); });
        // Form.find(".zag-validation-input-recaptcha").on("click", function () { ValidateRecaptcha($(this)); CountErrors($(this)); });
        // Form.find(".g-recaptcha-response").on("change input", function () {
        //     var captcha = Form.find(".zag-validation-input-recaptcha");

        //     ValidateRecaptcha(captcha);
        //     CountErrors(captcha);
        // });
        // Form.find(".zag-validation-input-recaptcha").each(function () {
        //     ValidateRecaptcha($(this));
        //     CountErrors($(this));
        // });
        // form.find(".zag-validation-input-checkbox").on("click", function () {
        //     var checkbox = $(this);

        //     validatecheckbox(checkbox);
        //     counterrors(checkbox);

        //     var captcha = form.find(".zag-validation-input-recaptcha");
        //     validaterecaptcha(captcha);
        //     counterrors(captcha);
        // });

        // Form.find(".recaptcha-checkbox").on("click", function () {
        //     var captcha = Form.find(".zag-validation-input-recaptcha");
        //     ValidateRecaptcha(captcha);
        //     CountErrors(captcha);
        // });
        // Form.find(".recaptcha-checkbox").on("change", function () {
        //     var captcha = Form.find(".zag-validation-input-recaptcha");
        //     ValidateRecaptcha(captcha);
        //     CountErrors(captcha);
        // });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // FORM SUBMIT
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function FormSubmit(Form) {
        // remove kentico's update and onsubmit functions
        var KenticoSubmit = Form.attr("onsubmit") || "",
            KenticoUpdate = Form.attr("data-ktc-ajax-update") || "";

        // normalize removal of attributes
        Form.removeAttr("onsubmit").removeAttr("data-ktc-ajax-update");

        Form.on("submit", function (e) {
            e.preventDefault();

            var $form = $(this);

            // prevent double submission
            if ($form.data('submitting')) {
                return false;
            }
            $form.data('submitting', true);
            $form.removeClass("kentico-form-loaded").addClass("kentico-form-submitted");

            // disable submit buttons immediately
            $form.find("input[type='submit'], button[type='submit']").prop('disabled', true);

            // different validation tactics
            $form.find(".zag-validation-input-text").each(function () { ValidateText($(this)); CountErrors($(this)); });
            $form.find(".zag-validation-input-radio").each(function () { ValidateRadio($(this)); CountErrors($(this)); });
            $form.find(".zag-validation-input-checkboxes").each(function () { ValidateCheckboxes($(this)); CountErrors($(this)); });
            $form.find(".zag-validation-input-checkbox").each(function () { ValidateCheckbox($(this)); CountErrors($(this)); });
            $form.find(".zag-validation-input-recaptcha").each(function () { ValidateRecaptcha($(this)); CountErrors($(this)); });
            $form.find(".zag-validation-input-file").each(function () { ValidateFile($(this)); CountErrors($(this)); });

            // if there are validation errors, re-enable and stop
            if ($form.find(".zag-validation-invalid").length > 0) {
                $form.find(".zag-validation-invalid").first().focus();
                $form.data('submitting', false);
                $form.find("input[type='submit'], button[type='submit']").prop('disabled', false).removeAttr('disabled');
                return false;
            }

            // restore kentico attributes if present
            if (KenticoSubmit !== "" || KenticoUpdate !== "") {
                var attrs = {};
                if (KenticoSubmit !== "") attrs.onsubmit = KenticoSubmit;
                if (KenticoUpdate !== "") attrs['data-ktc-ajax-update'] = KenticoUpdate;
                $form.attr(attrs);
            }

            // If Kentico provided ajax attributes, submit via AJAX so we can handle redirectTo responses
            var hasFiles = $form.find("input[type='file']").length > 0;
            if (KenticoSubmit !== "" || KenticoUpdate !== "") {
                var url = $form.attr('action') || window.location.href;
                var method = ($form.attr('method') || 'POST').toUpperCase();

                var ajaxOptions = {
                    url: url,
                    type: method,
                    success: function (resp) {
                        try {
                            // If response is JSON with redirectTo, navigate
                            if (resp && typeof resp === 'object' && resp.redirectTo) {
                                window.location.href = resp.redirectTo;
                                return;
                            }
                        }
                        catch (e) { }
                        
                        // default fallback: reload page
                        window.location.reload();
                    },
                    error: function (xhr, status, err) {
                        // re-enable buttons and allow retry
                        $form.data('submitting', false);
                        $form.find("input[type='submit'], button[type='submit']").prop('disabled', false).removeAttr('disabled');
                    }
                };

                if (hasFiles) {
                    var fd = new FormData($form[0]);
                    ajaxOptions.data = fd;
                    ajaxOptions.processData = false;
                    ajaxOptions.contentType = false;
                }
                else {
                    ajaxOptions.data = $form.serialize();
                }

                $.ajax(ajaxOptions);
                return;
            }

            // Otherwise perform native submit (non-AJAX form)
            try {
                $form.off('submit');
                $form[0].submit();
            }
            catch (err) {
                $form.data('submitting', false);
                $form.find("input[type='submit'], button[type='submit']").prop('disabled', false).removeAttr('disabled');
            }

            return;
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE TEXT
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateText(Component) {
        // validate individual input against required
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']").each(function () {
            Component.val() !== "" ? $(this).hide() : $(this).show()
        });

        // validate individual input against min-length
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='minlength']").each(function () {
            Component.val().length >= $(this).attr("data-rulemin") ? $(this).hide() : $(this).show()
        });

        // validate individual input against max-length
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='maxlength']").each(function () {
            Component.val().length <= $(this).attr("data-rulemax") ? $(this).hide() : $(this).show()
        });

        // validate individual input against compare to another field
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='compare']").each(function () {

            var Operator = $(this).attr("data-rulecomparison"),
                CompareGuid = $(this).attr("data-rulecomparisonfield"),
                CompareValue = $("[data-guid='" + CompareGuid + "']").val();

            if (Component.val() !== "" && CompareValue !== "") {
                if (Operator === "NotEqual") {
                    Component.val() !== CompareValue ? $(this).hide() : $(this).show()
                }
                else if (Operator === "Equal") {
                    Component.val() === CompareValue ? $(this).hide() : $(this).show()
                }
            }
            else {
                $(this).hide()
            }

        });

        // validate individual input against regex
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='regex']").each(function () {
            Component.val().match($(this).attr("data-ruleregex")) ? $(this).hide() : $(this).show()
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE RADIO
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateRadio(Component) {
        // because this is structured data we can assume no validation rule other than required is needed
        var ComponentName = Component.attr("name");
        var ComponentValue = $("input[name='" + ComponentName + "']:checked").val() || "";
        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']");
        ComponentValue !== "" ? ComponentError.hide() : ComponentError.show()
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE CHECKBOXES
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateCheckboxes(Component) {
        // because this is structured data we can assume no validation rule other than required is needed
        var ComponentGuid = Component.attr("data-guid");
        var ComponentValue = "";

        $("input[data-guid='" + ComponentGuid + "']:checked").each(function () { ComponentValue += $(this).val() + "|"; });
        ComponentValue.trimEnd("|");

        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']");
        ComponentValue !== "" ? ComponentError.hide() : ComponentError.show()
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE CHECKBOX
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateCheckbox(Component) {
        // bool is set is the only kentico validation for this component
        var ComponentCheckbox = Component.parents(".form-group").find(".zag-validation-input-checkbox");
        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='boolisset']");
        ComponentCheckbox.is(":checked") ? ComponentError.hide() : ComponentError.show()
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE FILE UPLOAD
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateFile(Component) {
        Component.parents(".form-group").find(".zag-validation-error[data-ruletype='required']").each(function () {
            Component.val() !== "" ? $(this).hide() : $(this).show()
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // VALIDATE RECAPTCHA
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function ValidateRecaptcha(Component) {
        var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='recaptcha']");
        var RecaptchaResponse = Component.parent().find(".g-recaptcha-response").val();
        RecaptchaResponse != "" ? ComponentError.hide() : ComponentError.show();
        // var Response = Component.parents(".form-group").find(".g-recaptcha-response").val();

        // Response && Response.length > 0 ? ComponentError.hide() : ComponentError.show();
    }
    //     var ComponentError = Component.parents(".form-group").find(".zag-validation-error[data-ruletype='recaptcha']");
    //     grecaptcha.getResponse().length > 0 ? ComponentError.hide() : ComponentError.show()
    // }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // COUNT ERRORS
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    function CountErrors(Component) {
        // count error messages of individual input and update ui
        // Component.parents(".form-group").find(".zag-validation-errors").css("display", "flex");
        Component.parents(".form-group").find(".zag-validation-errors").show();

        var ErrorContainer = Component.parents(".form-group").find(".zag-validation-errors"),
            ErrorContainerId = ErrorContainer.attr("id"),
            ErrorCount = ErrorContainer.children(".zag-validation-error:visible").length;

        if (ErrorCount > 0) {
            Component.addClass("zag-validation-invalid").attr("aria-describedby", ErrorContainerId);
            ErrorContainer.show();
        }
        else {
            Component.removeClass("zag-validation-invalid").attr("aria-describedby", "");
            ErrorContainer.hide();
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SharedForm.init();
});